module.exports = __webpack_public_path__ + "static/media/Group 2137.5918b424.png";